import moment from 'moment';
import numeral from 'numeral';

// let data = {
//       "v": "0.0.1",
//       "ts": 1710250318,
//       "uom": "ea",
//       "url": "https://www.boeingdistribution.com/product/BOLT/AN174-7/AN174-7",
//       "source": "boeingdistribution",
//       "currency": "USD",
//       "unique_id": "boeingdistribution_an174-7",
//       "description": "BOLT",
//       "is_in_stock": true,
//       "part_number": "AN174-7",
//       "qty_minimum": 1,
//       "category_url": "https://www.boeingdistribution.com/index.jsp",
//       "qty_in_stock": 1314,
//       "price_per_qty": [
//         {
//           "qty": 1,
//           "unit_price": 2.62
//         }
//       ],
//       "qty_multiples": 1,
//       "unique_id_hash": "3d77c60bd79e55dee6bc5aabb09fc17cd49e27f8",
//       "warning_message": null,
//       "input_part_number": "AN174-7",
//       "manufacturer_name": null,
//       "part_number_alternates": null,
//       "part_number_manufacturer": null
//     }

const columns_selenium = [
    // {
    //     label: 'URL',
    //     field: 'url',
    //     type: 'text',
    // },
    {
        label: 'Updated',
        field: 'ts',
        type: 'text',
        formatFn: (timestamp) => {
            if(timestamp){
            return moment.unix(timestamp).format('YYYY-MM-DD')
            }
            return timestamp
        }
    },
    {
        label: 'Source',
        field: 'source',
        type: 'text',
    },
    {
        label: 'Part Number',
        field: 'part_number',
        type: 'text',
    },
    {
        label: 'Description',
        field: 'description',
        type: 'text',
    },
    {
        label: 'Price Per Qty',
        field: 'price_per_qty',
        type: 'text',
        formatFn: (price_per_qty) => {
            // list of dicts {qty: 1, unit_price: 2.62}
            if (price_per_qty == null){
                return price_per_qty
            }
            
            if(price_per_qty.length == 0){
                return ''
            }else if(price_per_qty.length == 1){
                if(price_per_qty[0].qty == 1){
                    let price = price_per_qty[0].unit_price
                    return numeral(price).format('$0,0,0,0,0.00')
                }
                return `${price_per_qty[0].qty}: ${numeral(price_per_qty[0].unit_price).format('$0,0,0,0,0.00')}`
            }else if (price_per_qty.length > 1){
                let price_per_qty_str = ''
                for (let i = 0; i < price_per_qty.length; i++){
                    price_per_qty_str += `${price_per_qty[i].qty}: ${numeral(price_per_qty[i].unit_price).format('$0,0,0,0,0.00')} \n`
                }
                return price_per_qty_str
            }
            return price_per_qty
        }
    },
    {
        label: 'UOM',
        field: 'uom',
        type: 'text',
    },
    // {
    //     label: 'Currency',
    //     field: 'currency',
    //     type: 'text',
    // },
    {
        label: 'Is In Stock',
        field: 'is_in_stock',
        type: 'boolean',
    },
    {
        label: 'Qty Minimum',
        field: 'qty_minimum',
        type: 'number',
    },
    {
        label: 'Qty In Stock',
        field: 'qty_in_stock',
        type: 'number',
    },
    {
        label: 'Qty Multiples',
        field: 'qty_multiples',
        type: 'number',
    },
    {
        label: 'Warning Message',
        field: 'warning_message',
        type: 'text',
    },
    {
        label: 'Manufacturer Name',
        field: 'manufacturer_name',
        type: 'text',
    },
    {
        label: 'Part Number Alternates',
        field: 'part_number_alternates',
        type: 'text',
    },
    {
        label: 'Part Number Manufacturer',
        field: 'part_number_manufacturer',
        type: 'text',
    },
    {
        label: 'Input Part Number',
        field: 'input_part_number',
        type: 'text',
    },
    // {
    //     label: 'Category URL',
    //     field: 'category_url',
    //     type: 'text',
    // },

    // {
    //     label: 'Updated',
    //     field: 'time_updated',
    //     type: 'text',
    //     formatFn: (date) => {
    //         if(date){
    //         if(date.includes('T')){
    //             return date.split('T')[0]
    //         }
    //         }
    //         return date
    //     }
    // },
    // {
    //     label: 'Price',
    //     field: 'price',
    //     type: 'number',
    //     formatFn: (value) => {
    //         if(value){
    //         return numeral(value).format('$0,0,0,0,0.00')
    //         }
    //         return value
    //     }
    // }
];

export {columns_selenium};